import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
const PdfUpload = ({ pdf, index, handleFileChange, removePdfInput }) => {
  return (
    <Box
      sx={{
        width: 120,
        height: 120,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Index Badge */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: "7%",
          margin: "2px",
          transform: "translateX(-50%)",
          backgroundColor: "black",
          color: "white",
          width: 16,
          height: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          borderRadius: "50%",
        }}
      >
        {index + 1}
      </Box>

      {index > 0 && (
        <Box
          sx={{
            position: "absolute",
            top: 5,
            right: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={() => removePdfInput(index)}
            sx={{
              padding: 0,
              width: 16,
              height: 16,
            }}
          >
            <RemoveCircle color="error" sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      )}

      {/* PDF Preview */}
      <Box
        sx={{
          width: "100%",
          height: "80%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          padding: "0 4px",
          textAlign: "center",
        }}
      >
        {pdf && pdf !== "" ? (
          <Typography
            variant="caption"
            // sx={{
            //   wordWrap: "break-word",
            //   whiteSpace: "normal",
            //   maxWidth: "100%",
            //   fontSize: "10px",
            // }}
          >
            <embed src={pdf} type="application/pdf" width="100%" height="auto" />
          </Typography>
        ) : (
          <Typography variant="caption" sx={{ textAlign: "center" }}>
            No Pdf
          </Typography>
        )}
      </Box>

      {/* Hidden File Input */}
      <input
        type="file"
        accept=".pdf"
        style={{ display: "none" }}
        id={`pdf-upload-${index}`}
        onChange={(e) => handleFileChange(e, index, "pdfs")}
      />

      {/* Browse Button */}
      <label htmlFor={`pdf-upload-${index}`} style={{ width: "100%" }}>
        <Button
          component="span"
          fullWidth
          variant="contained"
          size="small"
          sx={{ borderTop: "1px solid #ccc", textTransform: "none" }}
        >
          Browse
        </Button>
      </label>
    </Box>
  );
};

export default PdfUpload;
